import { action, observable } from 'mobx';

import JsonServiceClient from 'bz-stores/lib/JsonServiceClient';
import AuthStore from 'bz-stores/lib/auth-store';
import history from 'bz-utilities/modules/networking/history/rr4';
import Api from 'tm3-core/api';
import { ChangePassword, ResetPassword, VerifyCode } from 'tm3-core/api.dtos';

class HelpStore {
  @observable authenticating: boolean = true;
  @observable authenticated: boolean = false;
  @observable loginObject: any = observable({ userName: '', password: '' });
  @observable user: any = observable({ location: {} });
  @observable loadingAuth: boolean = false;
  @observable newPasswordObject: any = observable({ loadingAuth: true });
  @observable error: boolean = false;
  client = new JsonServiceClient();

  @action.bound
  async resetPassword(email: string): Promise<boolean> {
    this.newPasswordObject = { loadingAuth: true };

    try {
      const res = await this.client.post(new ResetPassword({ email }));
      this.newPasswordObject = { loadingAuth: false };
      if (res.result) this.error = false;
      else this.error = true;
      return res.result;
    } catch (err) {
      this.error = true;
    }
  }

  @action.bound
  async verifyCode(code: string) {
    try {
      this.newPasswordObject = { loadingAuth: true };
      const result = await this.client.get(new VerifyCode({ code }));
      AuthStore.onAuthenticate(result, true);
      this.newPasswordObject = { loadingAuth: false, code };
      if (!result) {
        return history.push('/help');
      }
    } catch {
      return history.push('/help');
    }
  }

  @action.bound
  async changePassword(user: Partial<ChangePassword>, failedChange?: any) {
    this.loadingAuth = true;
    const res = await this.client.post(Object.assign(new ChangePassword(), user));
    await AuthStore.onAuthenticate(res);
  }
}

export default HelpStore;
